import {animate, query, style, transition, trigger} from '@angular/animations';

// Could not get this reusable stuff to work on the entire animation (maybe you're not supposed to, but what's the
//  point then? https://angular.dev/guide/animations/reusable-animations
export const slideInOut = trigger('slideInOut', [
	transition('open => close', [
		// Have to "animate" the leaving component for minimal time to keep it on the screen
		// https://github.com/angular/angular/issues/15477
		query(':leave', animate(1), { optional: true }),
		animate('0.3s', style({ transform: 'translateY(-100%)' }))
	]),
	// todo complex "swap" animation?
]);

